import { render } from "./edit.vue?vue&type=template&id=7db5b611"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=7db5b611&lang=less"
script.render = render

export default script